export default {
    pageTitle: 'CREATE - TREND RADAR'
}
